import { render, staticRenderFns } from "./LiondeskDialog.vue?vue&type=template&id=513639a2&lang=pug"
import script from "./LiondeskDialog.vue?vue&type=script&lang=js"
export * from "./LiondeskDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports